import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    component: () => import(/* webpackChunkName: "dashboard" */ "./routes/Dashboard"),
  },
  {
    path: "/filter/:filter",
    component: () => import(/* webpackChunkName: "dashboard" */ "./routes/Dashboard"),
  },
  {
    path: "/newinvoice/:action/:id",
    component: () => import(/* webpackChunkName: "newinvoice" */ "./routes/NewInvoice"),
  },
  {
    path: "/search/:action/:terms",
    component: () => import(/* webpackChunkName: "searchresults" */ "./routes/SearchResults"),
  },
  {
    path: "/edituser",
    component: () => import(/* webpackChunkName: "edituserdata" */ "./routes/EditUserData"),
  },
  {
    path: "/modules",
    component: () => import(/* webpackChunkName: "edituserdata" */ "./routes/Modules"),
  },
  {
    path: "/site/objectmanager",
    component: () => import(/* webpackChunkName: "objectmanager" */ "./routes/ObjectManager"),
    children: [
      {
        path: ':objectid',
        component: () => import(/* webpackChunkName: "objectmanager" */ "./routes/ObjectManager")
      }
    ]
  },
  {
    path: "/site/images",
    component: () => import(/* webpackChunkName: "editsiteImages" */ "./routes/EditSiteImages"),
    children: [
      {
        path: ':imageCategory',
        component: () => import(/* webpackChunkName: "editsiteImages" */ "./routes/EditSiteImages")
      }
    ]
  },
  {
    path: "/site/services",
    component: () => import(/* webpackChunkName: "editsiteServices" */ "./routes/EditServices"),
  },
  {
    path: "/admin/users",
    component: () => import(/* webpackChunkName: "ManageSiteUsers" */ "./routes/ManageSiteUsers"),
  },
  {
    path: "/admin/modules",
    component: () => import(/* webpackChunkName: "ManageModules" */ "./routes/ManageModules"),
  },
];

const router = new VueRouter({
  routes
});

export default router;
